import Application from "../../Application";
import { IApplicantFormService } from "../../service/form/ApplicantFormService";

export default class UpdateElectronicRegistryNumberInteractor {
  private application: Application;
  private applicantFormService: IApplicantFormService;

  constructor(application, applicantFormService) {
    this.application = application;
    this.applicantFormService = applicantFormService;
  }

  async execute(
    formVersionId: number,
    numberItemElectronicRegistry?: string,
    subNumberItemElectronicRegistry?: string
  ) {
    return this.applicantFormService.updateElectronicRegistryNumber(
      formVersionId,
      numberItemElectronicRegistry,
      subNumberItemElectronicRegistry
    );
  }
}
